import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import LSRgH1HeadLine from "./text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdH1HeadLine from "./text/linSeedKr/Bd/lsBdH1HeadLine";
import useDisplay from "../../hooks/useDisplay";

function Pagination({
  route,
  queryString,
  totalPages,
  currentPage,
  rangeSize,
  first,
  last,
  style,
  setPage,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const navigate = useNavigate();

  const pageList = useMemo(() => {
    const pageGroup = Math.ceil(currentPage / rangeSize);

    let firstNumber = pageGroup * rangeSize - (rangeSize - 1);
    if (firstNumber <= 0) {
      firstNumber = 1;
    }

    let lastNumber = pageGroup * rangeSize;
    if (lastNumber > totalPages) {
      lastNumber = totalPages;
    }

    const pageList = [];
    for (let i = firstNumber; i <= lastNumber; i++) {
      pageList.push(i);
    }

    return pageList;
  }, [totalPages, currentPage, rangeSize]);

  return (
    <>
      {pageList.length > 0 ? (
        <>
          <PagenationWrapper style={style} $isMobile={isMobile}>
            <img
              src="/assets/icons/left_arrow_c.png"
              alt="arrow-left"
              style={{
                width: isMobile ? 12 : 18,
                height: isMobile ? 12 : 18,
                cursor: "pointer",
              }}
              onClick={() => {
                if (first || Number(currentPage) === 1) {
                  return;
                }

                if (route) {
                  navigate(
                    route +
                      `?page=${Number(currentPage) - 1}${
                        queryString ? "&" + queryString : ""
                      }`
                    // { replace: true }
                  );
                } else {
                  setPage(Number(currentPage) - 1);
                }
              }}
            />
            <PagenationNumWrapper>
              {pageList.map((item, index) => {
                return Number(currentPage) === item ? (
                  <PagenationNumA
                    style={{
                      fontSize: isMobile ? 12 : 16,
                      lineHeight: isMobile ? "14.4px" : "22.4px",
                      width: isMobile ? 20 : 30,
                    }}
                    key={index}
                    onClick={() => {
                      if (route) {
                        navigate(
                          route +
                            `?page=${item}${
                              queryString ? "&" + queryString : ""
                            }`
                          // { replace: true }
                        );
                      } else {
                        setPage(Number(item));
                      }
                    }}
                  >
                    {item}
                  </PagenationNumA>
                ) : (
                  <PagenationNum
                    style={{
                      fontSize: isMobile ? 12 : 16,
                      lineHeight: isMobile ? "14.4px" : "22.4px",
                      width: isMobile ? 20 : 30,
                      textAlign: "center",
                    }}
                    key={index}
                    onClick={() => {
                      if (route) {
                        navigate(
                          route +
                            `?page=${item}${
                              queryString ? "&" + queryString : ""
                            }`
                          // { replace: true }
                        );
                      } else {
                        setPage(Number(item));
                      }
                    }}
                  >
                    {item}
                  </PagenationNum>
                );
              })}
            </PagenationNumWrapper>
            <img
              src="/assets/icons/right_arrow_c.png"
              alt="arrow-right"
              style={{
                width: isMobile ? 12 : 18,
                height: isMobile ? 12 : 18,
                cursor: "pointer",
              }}
              onClick={() => {
                if (last || Number(currentPage) === totalPages) {
                  return;
                }

                if (route) {
                  navigate(
                    route +
                      `?page=${Number(currentPage) + 1}${
                        queryString ? "&" + queryString : ""
                      }`
                    // { replace: true }
                  );
                } else {
                  setPage(Number(currentPage) + 1);
                }
              }}
            />
          </PagenationWrapper>
        </>
      ) : null}
    </>
  );
}

export default Pagination;

const PagenationWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: ${(props) => (props.$isSmall ? "40px" : "50px")};
`;

const PagenationNumWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const PagenationNum = styled(LSRgH1HeadLine).attrs((props) => {})`
  display: flex;

  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #c0c2c8;
`;

const PagenationNumA = styled(LSBdH1HeadLine).attrs((props) => {})`
  display: flex;

  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #101113;
`;
